import styled, { Media, Button } from 'easyguide'
import Sidebar from 'components/Sidebar'

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  ${Media.breakpoints.mobile`
    flex-direction: column-reverse;
  `};
`

export const WrapperContent = styled.div`
  display: flex;
  min-width: ${Media.sizes.desktop}px;
  overflow: auto;
  margin: 0;
  flex: 1;
  top: 63px;

  ${Media.breakpoints.desktop`
    min-width: 100%;
    max-width: 100%;
  `}

  ${Media.breakpoints.mobile`
    flex-direction: column;
    overflow: auto;
    margin: 0 auto;
    top: 0;
  `};
`

export const MobileHeader = styled.div`
  margin-top: 33px;
  display: flex;
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
`

export const SidebarComponent = styled(Sidebar)`
  flex: 0 1 360px;
  min-width: 360px;
  height: 100%;
  border-right: 1px solid ${({ theme }) => theme.Template.borderColor};

  ${Media.breakpoints.mobile`
    flex: 1 0 auto;
    border-right: 0;
    min-width: auto;
  `};
`

export const ContentComponent = styled.section`
  flex: 1;
  min-width: 456px;
  overflow: auto;

  ${Media.breakpoints.mobile`
    margin-left: 0;
    min-width: auto;
    width: auto;
    overflow: initial;
  `};
`

export const BackButton = styled(Button)`
  width: auto;
  height: auto;
  margin: 10px;
`

export const ExternalContentWrapper = styled.div`
  width: 100%;
  height: auto;
`

export const ContentWrapper = styled.div`
  padding: 80px 10px 20px;
  height: auto;
  ${Media.breakpoints.mobile`
    padding: 40px 20px 20px;
  `};
`
